import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { fetchUpcomingAppointment } from "../../../../shared/hooks/useFetchAppointment";
import API_URLS from "../../Utils/axr";
import {
  checkIsPastDate,
  checkIsUpcommingAppointment,
} from "../../../../shared/utils/dateUtils";
import { errorConditionGTM } from "../../Utils/googleTags";
import store from "../store";
import { getServiceAddressFromUser } from "../../Utils/utils";
import DwLogutil from "../../Utils/DwLogutil";
import { EC_DW_LOGGING_STEPS } from "../../../../shared/utils/Constants";
import moment from "moment";

type upcomingAppointmentInitialStateType = {
  upcomingAppointment: any;
  rescheduleStatus: string;
  loading: boolean;
  error: any;
};
const initialState: upcomingAppointmentInitialStateType = {
  upcomingAppointment: null,
  rescheduleStatus: localStorage.getItem("rescheduling") || "no",
  loading: false,
  error: null,
};

// export const getUpcomingAppointment = createAsyncThunk(
//   "upcoming/appointment",
//   async (user: any) => {
//     try {
//       const { billingAccountNumber, email } = user;
//       const response = await fetchUpcomingAppointment({
//         // [API_URLS?.upComingAppointmentUrl]: `${billingAccountNumber}?email=${email}`,
//         [API_URLS?.fetchPastAppointments]: `?email=${email}`
//       });
//       return response?.data;
//     } catch (error) {
//       throw error;
//     }
//   }
// );

export const getUpcomingAppointment = createAsyncThunk(
  "upcoming/appointment",
  async (user: any) => {
    try {
      const { billingAccountNumber, email, isFromOtherAgent } = user;
      const serviceAddLocal = getServiceAddressFromUser(user);
      const reduxStore = store.getState();
      const headers = reduxStore?.brightspeedToken?.headers;
      let url=API_URLS['upComingAppointmentUrl_QA'];
      const response = await fetchUpcomingAppointment(
        {
          "": `${
            process.env.REACT_APP_ENV === "QA"
              ? url
              : API_URLS?.fetchPastAppointments
          }?ban=${billingAccountNumber}&addressId=${
            serviceAddLocal?.addressId
          }`,
        },
        headers
      );
      const respData = response?.data;
      // const respData: any = [];

      const sortedAppointmentDataForOrderNumber =
        respData?.userAppointments[0]?.order?.sort(
          (a: any, b: any) =>
            new Date(b?.apptDetails?.appointmentDate)?.valueOf() -
            new Date(a?.apptDetails?.appointmentDate)?.valueOf()
        );
      const validOrderStatus = sortedAppointmentDataForOrderNumber?.length > 0
        ? sortedAppointmentDataForOrderNumber?.filter(
          (item: any) => !(item?.orderStatus?.toLowerCase()?.includes("object"))
        ) || ""
        : "";
      const latestAppontmentDetails =
      validOrderStatus?.length > 0
          ? validOrderStatus?.find(
              (item: any) => item?.orderNumber && item?.orderStatus?.toLowerCase() !== "canceled"
            ) || ""
          : "";
      
      let pendingOrderDetails = [];
      const respDataMapped = {
        upcomingAppointments: [
          {
            orderDetails: {
              pendingDisconnectDate: respData?.userAppointments[0]?.disconnectDueDate || null,
              pendingOrderDetails: respData?.userAppointments[0]?.order.filter(
                (anOrder: any) => {
                  if (
                    !isFromOtherAgent &&
                    anOrder?.installType?.toUpperCase() !== "S" &&
                    anOrder?.apptDetails?.appointmentDate &&
                    anOrder?.apptDetails?.appointmentStartTime &&
                    checkIsUpcommingAppointment(
                      anOrder?.apptDetails?.appointmentDate
                    ) &&
                    (anOrder?.orderStatus !== "Canceled" || !anOrder?.orderStatus?.includes("Cancel") || anOrder?.orderStatus !== "Completed")
                  ) {
                    if(!anOrder?.dispatchInfo?.hasOwnProperty('taskStatus') || !anOrder?.dispatchInfo) {
                      DwLogutil({
                        stepName: EC_DW_LOGGING_STEPS?. invalid_upcomming_appointment_dispatch_info,
                        error: "Invalid dispatch info"
                      })
                    }
                    return anOrder;
                  } else if (
                  
                    isFromOtherAgent &&
                    anOrder?.apptDetails?.appointmentDate &&
                    anOrder?.apptDetails?.appointmentStartTime &&
                    (anOrder?.orderStatus !== "Canceled" &&
                    anOrder?.orderStatus !== "Completed" &&
                    anOrder?.orderStatus !== "Cannot Complete"|| 
                    !anOrder?.orderStatus?.includes("Cancel"))
                  ) {
                    
                    return anOrder;
                  }
                }
              ),
              pastAppointment: respData?.userAppointments[0]?.order?.filter(
                (anOrder: any) =>
                  checkIsPastDate(anOrder?.apptDetails?.appointmentDate) ||
                  anOrder?.orderStatus === "Canceled" ||
                  anOrder.orderStatus === "Completed" ||
                  anOrder.orderStatus === "Cannot Complete" ||
                  anOrder?.orderStatus?.includes("Cancel")
              ),
            },
          },
        ],
        orderId: latestAppontmentDetails?.orderNumber || "",
        orderStatusForWallgarden: latestAppontmentDetails?.orderStatus || "",
      };
      return respDataMapped;
    } catch (error) {
      console.error(error);
      DwLogutil({
        stepName: EC_DW_LOGGING_STEPS?.upcoming_appointment_failure,
        error: `${error}`
      })
      throw error;
    }
  }
);

const upcomingAppointmentSlice = createSlice({
  name: "upcoming/appointment",
  initialState,
  reducers: {
    clearUpcomingAppointmentSlice: (state) => {
      return initialState;
    },
    setRescheduleStatus: (state, action) => {
      state.rescheduleStatus = action.payload;
      return state;
    },
    upcomingAppointmentSliceSetInitialState: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getUpcomingAppointment.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getUpcomingAppointment.fulfilled, (state, action) => {
      state.upcomingAppointment = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getUpcomingAppointment.rejected, (state, action) => {
      errorConditionGTM(
        "BRSPD_Fiber_EC_Flow",
        "upcomming appointment",
        action.error?.message,
        action?.type
      );
      state.upcomingAppointment = null;
      state.loading = false;
      state.error = action.error;
    });
  },
});

export const {
  clearUpcomingAppointmentSlice,
  setRescheduleStatus,
  upcomingAppointmentSliceSetInitialState,
} = upcomingAppointmentSlice.actions;
export default upcomingAppointmentSlice.reducer;
